import React from "react";
import { Switch } from "antd";
import { useApolloClientContext } from "./ApolloClientContext";

const LevelSwitcher: React.FC = () => {
  const { level, setLevel } = useApolloClientContext();

  const handleChange = (checked: boolean) => {
    setLevel(checked ? "secundaria" : "primaria");
  };

  return (
    <div style={{ display: "inline-flex", alignItems: "center", marginRight: 16 }}>
      <span style={{ marginRight: 8, fontWeight: level === "primaria" ? "bold" : "normal" }}>
        Primaria
      </span>
      <Switch
        checked={level === "secundaria"}
        onChange={handleChange}
        checkedChildren="Secundaria"
        unCheckedChildren="Primaria"
        style={{ background: level === "secundaria" ? "#1890ff" : undefined }}
      />
      <span style={{ marginLeft: 8, fontWeight: level === "secundaria" ? "bold" : "normal" }}>
        Secundaria
      </span>
    </div>
  );
};

export default LevelSwitcher;
